import React from 'react'
import {Box, Typography} from '@mui/material'
import {toCommaSeparatedDecimal} from "../../../utility/componentUtil";
import {CartItem} from '../../../context/CartContext';
import CCOPicture from "../../fundamentals/CCOPicture";
import CCOHeadline from "../../fundamentals/CCOHeadline";
import P015CartItemCounter from "./P015CartItemCounter";
import {t} from "i18next";
import useWindowSize from "../../../utility/useWindowSize";


export interface Props {
    item: CartItem
    pageSettings?: any
    disableDeleteButton?: boolean
}

function P015CartItem({item, disableDeleteButton}: Props) {
    const {
        sosPublication: {
            id, picture, title,
        }, price
    } = item;
    const {greaterThanWindowLarge, lowerThanWindowSmall} = useWindowSize()

    const ariaLabelText = `${title}, ${t("cart.item_price")} ${toCommaSeparatedDecimal(price)} €, ${t("cart.count")} ${item.quantity}`;

    return (<>
        <Box data-cypress={'cartItem'} key={id}
             sx={{
                 display: 'grid',
                 gridTemplateColumns: 'auto 1fr',
                 gridTemplateRows: 'auto auto',
                 gap: '24px',
                 width: '100%',
                 justifyItems: 'start',
                 alignItems: 'start',
             }}>
            <Box sx={{
                gridColumn: '1 / 2',
                gridRow: {
                    xs: '1 / 2',
                    sm: '1 / 3',
                },
            }}>
                <CCOPicture name={picture?.name}
                            picture={picture}
                            orientation={'portrait_ratio3x4'}
                            width={'780'}
                            height={'1040'}
                            sxContainer={{
                                boxShadow: '0px 4px 5px 0px rgba(0, 0, 0, 0.14)',
                                width: {
                                    xs: '74px',
                                    sm: '120px',
                                    md: '122px',
                                    lg: '172px',
                                    xl: '229px',
                                },
                                height: {
                                    xs: '99px',
                                    sm: '160px',
                                    md: '163px',
                                    lg: '229px',
                                    xl: '304px',
                                },
                            }}/>
            </Box>
            <Box sx={{
                gridColumn: '2 / 3',
                gridRow: '1 / 3',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'space-between',
                gap: '1rem',
                justifyContent: greaterThanWindowLarge ? 'space-between' : 'flex-start',
                padding: greaterThanWindowLarge ? '1rem' : '0',
            }}>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'start',
                    }}
                    tabIndex={0}
                    aria-label={ariaLabelText}
                >
                    <CCOHeadline color={'text.primary'} type={'h4'} headline={title}
                    />
                    <Typography variant={'body1'}>{`${t("cart.item_price")}: ${toCommaSeparatedDecimal(price)} €`}</Typography>
                </Box>
                {!lowerThanWindowSmall && <P015CartItemCounter item={item} disableDeleteButton={disableDeleteButton}/>}
            </Box>
            {lowerThanWindowSmall && <P015CartItemCounter item={item} disableDeleteButton={disableDeleteButton}/>}

        </Box>
    </>)
}

export default P015CartItem
